// extracted by mini-css-extract-plugin
export default {"content":"TreePage_content__EydwZ","trees_grid":"TreePage_trees_grid__pABvv"};